var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19.8453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Laptop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9938,15.9696h6.0024v1.0004h-6.0024v-1.0004h0ZM22.9897,17.9704H.9905v-1.3768l1.8126-3.6154h18.3937l1.8028,3.6154v1.3867h-.0099v-.0099h0ZM2.9913,2.469c0-.832-.0763-1.5608,1.4956-1.4957h14.9962c.832,0,1.6998-.0041,1.4956,1.4957v9.4989H2.9813V2.469h.0101,0ZM21.9893,12.3344V1.2654c0-.7084-.5742-1.2826-1.2826-1.2826H3.2834c-.7083,0-1.2826.5743-1.2826,1.2826v11.0888l-2.0008,4.0017v2.6149h24v-2.6149l-2.0008-4.0215h-.0099Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9938,15.9696h6.0024v1.0004h-6.0024v-1.0004h0ZM22.9897,17.9704H.9905v-1.3768l1.8126-3.6154h18.3937l1.8028,3.6154v1.3867h-.0099v-.0099h0ZM2.9913,2.469c-.1714-1.4957.6736-1.4957,1.4956-1.4957h14.9962c.832,0,1.6162-.1206,1.4956,1.4957v9.499H2.9813V2.469h.0101,0ZM21.9893,12.3344V1.2654c0-.7084-.5742-1.2826-1.2826-1.2826H3.2834c-.7083,0-1.2826.5743-1.2826,1.2826v11.0888l-2.0008,4.0017v2.6149h24v-2.6149l-2.0008-4.0215h-.0099Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.1d7dd13786841e0eb55b72d2aebb2f90.svg";
export { ForwardRef as ReactComponent };